export default {
  about: "О нас",
  readMore: "Подробнее",
};
